export default "__VITE_ASSET__2fdd744e__"